import { CustomModal } from "Componentes/CustomModal/CustomModal";
import { LoadingLogo } from "Developers/EstebanCaccin/components/LoadingLogo/LoadingLogo";

import "./project.scss";

type TProject = {
  name: string;
  isOpen: boolean;
  onClose: () => void;
};

export const Project = ({ name, isOpen, onClose }: TProject) => {
  if (!isOpen) {
    return <LoadingLogo />;
  }
  return (
    <CustomModal className='project-modal' isOpen={isOpen} onClose={onClose}>
      <div>
        <div>Próximamente</div>
        <div className='d-none'>{name}</div>
      </div>
    </CustomModal>
  );
};
